var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 947,
    height: 401,
    viewBox: "0 0 947 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.984 320.384C355.384 320.384 411.644 266.572 411.644 200.192C411.644 133.812 355.384 80 285.984 80C216.584 80 160.324 133.812 160.324 200.192C160.324 266.572 216.584 320.384 285.984 320.384ZM285.984 303.774C345.793 303.774 394.279 257.399 394.279 200.192C394.279 142.985 345.793 96.6094 285.984 96.6094C226.174 96.6094 177.689 142.985 177.689 200.192C177.689 257.399 226.174 303.774 285.984 303.774Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M242.143 192.599L294.567 120.928H346.189L295.803 171.928H315.527L275.131 216.027H300.454L225.778 279.161L245.33 240.23H227.415L273.323 192.599H242.143Z",
    fill: "#ED2124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.644 300.192V100.192H545.907V252.13H587.768V300.192H491.644Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M603.272 300.192V100.192H657.535V300.192H603.272Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M671.731 147.479V100.192H786.217V147.479H755.985V300.192H701.721V147.479H671.731Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logoText.431cb98a0c24dec9cfe8f4a9f20b96c2.svg";
export { ForwardRef as ReactComponent };